// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MaterialListingHistoryQueryVariables = Types.Exact<{
  materialListingId: Types.Scalars['ID']['input'];
}>;


export type MaterialListingHistoryQuery = { __typename?: 'Query', materialListings: { __typename?: 'MaterialListingsPage', entities: Array<{ __typename?: 'MaterialListing', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> }> } };


export const MaterialListingHistoryDocument = gql`
    query MaterialListingHistory($materialListingId: ID!) {
  materialListings(filter: {id: [$materialListingId]}) {
    entities {
      id
      history {
        ...HistoryFeedInfo
      }
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useMaterialListingHistoryQuery__
 *
 * To run a query within a React component, call `useMaterialListingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialListingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialListingHistoryQuery({
 *   variables: {
 *      materialListingId: // value for 'materialListingId'
 *   },
 * });
 */
export function useMaterialListingHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables> & ({ variables: MaterialListingHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>(MaterialListingHistoryDocument, options);
      }
export function useMaterialListingHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>(MaterialListingHistoryDocument, options);
        }
// @ts-ignore
export function useMaterialListingHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>;
export function useMaterialListingHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialListingHistoryQuery | undefined, MaterialListingHistoryQueryVariables>;
export function useMaterialListingHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>(MaterialListingHistoryDocument, options);
        }
export type MaterialListingHistoryQueryHookResult = ReturnType<typeof useMaterialListingHistoryQuery>;
export type MaterialListingHistoryLazyQueryHookResult = ReturnType<typeof useMaterialListingHistoryLazyQuery>;
export type MaterialListingHistorySuspenseQueryHookResult = ReturnType<typeof useMaterialListingHistorySuspenseQuery>;
export type MaterialListingHistoryQueryResult = Apollo.QueryResult<MaterialListingHistoryQuery, MaterialListingHistoryQueryVariables>;